import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import { LEAGUES, League } from './registerConstants';
import { RegisterFormState } from './registerTypes';

interface RegisterStepLeagueProps {
  form: RegisterFormState;
  update: (patch: Partial<RegisterFormState>) => void;
  onContinue: () => void;
  onBack: () => void;
}

const RegisterStepLeague: React.FC<RegisterStepLeagueProps> = ({ form, update, onContinue, onBack }) => {
  const { t } = useTranslation();

  const select = (league: League) => update({ league });
  const canContinue = form.league !== null;

  return (
    <div className="register__card">
      <h1 className="register__title italic-title">{t.register.leagueTitle}</h1>
      <p className="register__subtitle">{t.register.leagueSubtitle}</p>

      <div className="register__chip-scroller">
        {LEAGUES.map((league) => {
          const selected = form.league?.id === league.id;
          return (
            <button
              key={league.id}
              type="button"
              className={`register__league-chip${selected ? ' register__league-chip--active' : ''}`}
              onClick={() => select(league)}
              aria-pressed={selected}
            >
              {league.name}
            </button>
          );
        })}
      </div>

      <div className="register__nav">
        <button type="button" className="register__back" onClick={onBack}>
          {t.register.back}
        </button>
        <button
          type="button"
          className="register__submit button_primary"
          onClick={onContinue}
          disabled={!canContinue}
        >
          {t.register.continue}
        </button>
      </div>
    </div>
  );
};

export default RegisterStepLeague;
